import * as yup from "yup";

export const festivalSchema = yup
  .object({
    title: yup.string().required().default(""),
    description: yup.string().default("").nullable(),
    show_ids: yup.array().of(yup.string().required()).default([]),
  })
  .required();
